/**
 * @file コンポーネント：ログインモーダル スタイル管理
 */

// ライブラリ読み込み
import styled, { keyframes } from "styled-components";

// スタイル
export const StyledModal = styled.div``;

export const StyledModalContainer = styled.section``;

export const StyledModalContainerAnchor = styled.a`
    color: #000000;
    font-size: 14px;
    line-height: 18px;
`;

export const StyledModalContainerButton = styled.a`
    display: block;
    min-width: 88px;
    padding: 6px 8px;
    border-radius: 4px;
    background-color: #061c72;
    color: #ffffff;
    font-size: 14px;
    line-height: 24px;
    text-align: center;
`;

export const StyledModalContainerButtonlist = styled.ul`
    display: flex;
    justify-content: flex-end;
    margin-bottom: 24px;

    &:last-child {
        margin-bottom: 0;
    }
`;

export const StyledModalContainerButtonlistItem = styled.li`
    margin-right: 4px;

    &:last-of-type {
        margin-right: 0;
    }
`;

export const StyledModalContainerContent = styled.div`
    margin-bottom: 24px;

    &:last-child {
        margin-bottom: 0;
    }

    > input {
        width: 100%;
    }
`;

export const StyledModalContainerNotelist = styled.ul`
    margin-bottom: 24px;

    &:last-child {
        margin-bottom: 0;
    }
`;

export const StyledModalContainerNotelistItem = styled.li`
    color: #757575;
    font-size: 13px;
    line-height: 16px;
`;

export const StyledModalContainerHeadline = styled.h3`
    margin-bottom: 24px;
    color: #212121;
    font-weight: normal;
    font-size: 20px;
    line-height: 28px;
`;

export const StyledModalHeadline = styled.h2`
    margin-bottom: 24px;
    color: #212121;
    font-weight: normal;
    font-size: 20px;
    line-height: 28px;
`;

export const fadeIn = keyframes`
  0% { opacity: 0; transform: translateY(-2px); }
  100% { opacity: 1; transform: translateY(0); }
`;

export const FadeInParagraph = styled.p`
  color: red;
  animation: ${fadeIn} 3.0s ease;
  margin: 0.25rem 0;
`;

export const StyledFormInputWrapper = styled.div`
    /*isErrorのスタイルを優先したいため、isErrorより手前に置く*/
    &.isReset > input {
        border: 2px solid #2c7cda;
    }

    &.isError > input,
    &.isError > div > select,
    &.isError > div > div,
    &.isError > div.isError {
        border: 2px solid #ff0000;
    }
`;

export const StyledFormListDetailPassword = styled.div`
    position: relative;
    max-width: 664px;

    & > div > input {
        padding-right: 40px;
    }
`;

export const StyledFormListDetailShowPasswordIcon = styled.button`
    position: absolute;
    top: 50%;
    right: 8px;
    transform: translateY(-50%);
    width: 32px;
    height: 32px;
    border: none;
    background-color: transparent;
    color: #999999;
    font-size: 20px;
    line-height: 32px;
    text-align: center;
    /* ここを追加 */
    -webkit-user-select: none;
    user-select: none;
    -webkit-touch-callout: none;
`;
